<template>
  <div id="login-wrapper">
    <div class="left-wrapper">
      <div class="logo-wrapper">
        <a href="#">
          <img src="../../assets/logo.png" alt="logo" style="max-width: 220px">
        </a>
      </div>
      <div id="wrapper-form">
        <h1>{{ $t('pages.resetPassword.title') }}</h1>
        <ResetPasswordForm />
        <LanguageSwitcher />
      </div>
    </div>
    <div class="right-wrapper">
      <section class="landing-banner">
        <div class="wrapper">
          <h1 class="title">{{ $t('pages.login.rightTitle') }}</h1>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import ResetPassword from './ResetPassword';
export default ResetPassword;
</script>